import React from 'react';
import { Form } from 'react-bootstrap';

interface DurationSelectProps {
  value: number | string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  isRtl?: boolean;
  t: (key: string) => string;
  className?: string;
  style?: React.CSSProperties;
}

const DurationSelect: React.FC<DurationSelectProps> = ({ value, onChange, isRtl = false, t, className = '', style = {}, }) => {

  const durationOptions = Array.from({ length: (180 - 15) / 15 + 1 }, (_, i) => {
    const minutes = 15 * (i + 1);
    let label = `${minutes} ${t('minutes')}`;

    if (minutes % 60 === 0) {
      const hours = minutes / 60;
      const hourLabel = hours > 1 ? t('hours') : t('hour');
      label += ` (${hours} ${hourLabel})`;
    }

    return (
      <option key={minutes} value={minutes}>
        {label}
      </option>
    );
  });

  return (
    <Form.Select
      value={value}
      onChange={onChange}
      className={`dark-select bg-secondary bg-opacity-25 text-light ${isRtl ? 'ms-2' : 'me-2'} ${className}`}
      style={style}
    >
      <option value="">{t('enter-duration-in-minutes')}</option>
      {durationOptions}
    </Form.Select>
  );
};

export default DurationSelect;